import {APIActionStatus, Form, formsStore} from '../../../stores/Form';
import {startRecordDelete} from './form';
import {callLinkedActions} from './screen';

export const reorganizeRecordsAfterDelete = (currentForm: Form) => {
    if (currentForm.records.length < 2) {
        currentForm.insertEmptyRecord(currentForm.records.length);
    }
    const currentColumnIndex = currentForm.currentColumn.index || 0;
    currentForm.tableAPI.focusCell(currentColumnIndex, Math.max(currentForm.currentRow - 1, 0));
};

export const deleteRecord = async (currentForm: Form, callback?: () => void) => {
    const row = currentForm.currentRecord;
    if (row?.keys || row?.getField(currentForm.currentColumnId)?.currentValue) {
        await callLinkedActions(
            async () => {
                if (formsStore.currentScreen.activeLevel !== currentForm.level) {
                    return formsStore.currentScreen.handleFormLevel(currentForm.level);
                }
                return APIActionStatus.passed;
            },
            async () => {
                await startRecordDelete(row, async () => {
                    if (!currentForm.parentForm) {
                        callback?.();
                    }
                    reorganizeRecordsAfterDelete(currentForm);
                });
                return APIActionStatus.passed;
            }
        );
    }
};
